var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 44,
    viewBox: "0 0 66 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2125 16.61C51.3425 7.1225 43.01 0 33 0C25.0525 0 18.15 4.51 14.7125 11.11C6.435 11.99 0 19.0025 0 27.5C0 36.6025 7.3975 44 16.5 44H52.25C59.84 44 66 37.84 66 30.25C66 22.99 60.3625 17.105 53.2125 16.61ZM38.5 24.75V35.75H27.5V24.75H19.25L33 11L46.75 24.75H38.5Z",
    fill: "#C0AE9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.9a5b8a58f3b10f54dc10d0072e8ea0e0.svg";
export { ForwardRef as ReactComponent };